import * as PROJECT_CODE from '../../constants/projectCode';
import firebase from '../../lib/firebase.prod';

export default async function getMapCoordinates(
	userDetails,
	mapCoords,
	setMapCoords
) {
	let coBrokerId;
	let coBrokerAssignedLots = [];

	if (userDetails.userType === 'cobroker') {
		await firebase
			.database()
			.ref('/kavtek_coBrokers/' + PROJECT_CODE.projectCode)
			.orderByChild('userId')
			.equalTo(userDetails.uid)
			.once('value', async (snapshot) => {
				let coBrokerObj = snapshot.val();
				if (coBrokerObj) {
					let coBrokerKeys = Object.keys(coBrokerObj);
					if (coBrokerKeys.length > 0) {
						coBrokerId = coBrokerKeys[0];
						if (coBrokerId) {
							await firebase
								.database()
								.ref('/kavtek_lots/' + PROJECT_CODE.projectCode)
								.orderByChild('assignedCoBroker')
								.equalTo(coBrokerId)
								.once('value', (snapshot) => {
									let coBrokerAssignedLotsObj =
										snapshot.val();
									if (coBrokerAssignedLotsObj) {
										coBrokerAssignedLots = Object.values(
											coBrokerAssignedLotsObj
										);
									}
								});
							await firebase
								.database()
								.ref('/kavtek_lots/' + PROJECT_CODE.projectCode)
								.on('value', (snapshot) => {
									var mapCoordObj;
									var areaArr = [];

									snapshot?.forEach((lot) => {
										var mapCoordVal = lot.val()?.mapCoords;
										if (
											userDetails.userType ===
												'cobroker' &&
											coBrokerAssignedLots.length > 0
										) {
											if (
												lot.val()?.assignedCoBroker ===
												coBrokerId
											) {
												if (
													lot.val().available ===
													'soldout'
												) {
													mapCoordVal[
														'preFillColor'
													] = 'rgba(255, 0, 0, 0.47)';
												}
												if (
													lot.val().available ===
													'available'
												) {
													// mapCoordVal[
													// 	'preFillColor'
													// ] = '';
													mapCoordVal[
														'preFillColor'
													] = '#3cc33cb8';
												}
												if (
													lot.val().available ===
													'pending'
												) {
													mapCoordVal[
														'preFillColor'
													] =
														'rgba(255, 255, 168, 0.70)';
												}
												if (
													lot.val().available ===
													'hold'
												) {
													mapCoordVal[
														'preFillColor'
													] = 'rgba(97, 97, 97, 1)';
													mapCoordVal[
														'disabled'
													] = true;
												}
											} else {
												mapCoordVal['preFillColor'] =
													'#ccc';
												mapCoordVal['disabled'] = true;
											}
										} else {
											if (
												lot.val().available ===
												'soldout'
											) {
												mapCoordVal['preFillColor'] =
													'rgba(255, 0, 0, 0.47)';
												mapCoordVal['name'] = 'soldout';
											}
											if (
												lot.val().available ===
												'available'
											) {
												// mapCoordVal[
												// 	'preFillColor'
												// ] = '';
												mapCoordVal['preFillColor'] =
													'#3cc33cb8';
												mapCoordVal['name'] =
													mapCoordVal['id'];
											}
											if (
												lot.val().available ===
												'pending'
											) {
												mapCoordVal['preFillColor'] =
													'rgba(255, 255, 168, 0.70)';
												mapCoordVal['name'] = 'pending';
											}
											if (
												lot.val().available === 'hold'
											) {
												mapCoordVal['preFillColor'] =
													'rgba(97, 97, 97, 1)';
												mapCoordVal['disabled'] = true;
												mapCoordVal['name'] = 'hold';
											}
										}

										areaArr.push(mapCoordVal);

										mapCoordObj = {
											...mapCoords,
											areas: areaArr,
										};
									});

									setMapCoords(mapCoordObj);
								});
						}
					}
				}
			});
	} else {
		await firebase
			.database()
			.ref('/kavtek_lots/' + PROJECT_CODE.projectCode)
			.on('value', (snapshot) => {
				var mapCoordObj;
				var areaArr = [];

				snapshot?.forEach((lot) => {
					var mapCoordVal = lot.val()?.mapCoords;

					// var coordsArray = mapCoordVal.coords;

					// var maxX, maxY, center;
					// var coord,
					//     minX = (maxX = parseInt(coordsArray[0], 10)),
					//     minY = (maxY = parseInt(coordsArray[1], 10));

					// for (var i = 0, l = coordsArray.length; i < l; i++) {
					//     coord = parseInt(coordsArray[i], 10);
					//     if (i % 2 == 0) {
					//         // Even values are X coordinates
					//         if (coord < minX) {
					//             minX = coord;
					//         } else if (coord > maxX) {
					//             maxX = coord;
					//         }
					//     } else {
					//         // Odd values are Y coordinates
					//         if (coord < minY) {
					//             minY = coord;
					//         } else if (coord > maxY) {
					//             maxY = coord;
					//         }
					//     }
					// }

					// center = [
					//     parseInt((minX + maxX) / 2, 10),
					//     parseInt((minY + maxY) / 2, 10),
					// ];

					// ---------DO NOT REMOVE THIS COMMENT ----------------------
					//Uncomment to populate db then comment it back! - This is to get the center coordinates of the each lots

					// var lotRef = firebase
					// 	.database()
					// 	.ref(
					// 		'/kavtek_clients/' +
					// 			PROJECT_CODE.projectCode +
					// 			'/lots'
					// 	)
					// 	.child(lot.key);

					// lotRef.update({
					// 	center: center,
					// });
					// -------------------------------------------------

					if (
						userDetails.userType === 'cobroker' &&
						coBrokerAssignedLots.length > 0
					) {
						if (lot.val()?.assignedCoBroker === coBrokerId) {
							if (lot.val().available === 'soldout') {
								mapCoordVal['preFillColor'] =
									'rgba(255, 0, 0, 0.47)';
							}
							if (lot.val().available === 'available') {
								mapCoordVal['preFillColor'] = '#3cc33cb8';
							}
							if (lot.val().available === 'pending') {
								mapCoordVal['preFillColor'] =
									'rgba(255, 255, 168, 0.70)';
							}
							if (lot.val().available === 'hold') {
								mapCoordVal['preFillColor'] =
									'rgba(97, 97, 97, 1)';
								mapCoordVal['disabled'] = true;
							}
						} else {
							mapCoordVal['preFillColor'] = '#ccc';
							mapCoordVal['disabled'] = true;
						}
					} else {
						if (lot.val().available === 'soldout') {
							mapCoordVal['preFillColor'] =
								'rgba(255, 0, 0, 0.47)';
							mapCoordVal['name'] = 'soldout';
						}
						if (lot.val().available === 'available') {
							mapCoordVal['preFillColor'] = '#3cc33cb8';
							mapCoordVal['name'] = mapCoordVal['id'];
						}
						if (lot.val().available === 'pending') {
							mapCoordVal['preFillColor'] =
								'rgba(255, 255, 168, 0.70)';
							mapCoordVal['name'] = 'pending';
						}
						if (lot.val().available === 'hold') {
							mapCoordVal['preFillColor'] = 'rgba(97, 97, 97, 1)';
							mapCoordVal['disabled'] = true;
							mapCoordVal['name'] = 'hold';
						}
					}

					areaArr.push(mapCoordVal);

					mapCoordObj = {
						...mapCoords,
						areas: areaArr,
					};
				});

				setMapCoords(mapCoordObj);
			});
	}
}
